import { createRoute, redirect } from "@tanstack/react-router";
import { versionLayoutRoute } from "./version-layout-route";

/**
 * Legacy path: Translate is no longer a version tab.
 * Each target locale is a forked version; create via header dialog.
 */
export const versionTranslateRoute = createRoute({
  getParentRoute: () => versionLayoutRoute,
  path: "/translate",
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/cases/$caseId/versions",
      params: { caseId: params.caseId },
    });
  },
});
